__webpack_require__.p = "/bideaze/";